export const places = {
    first:{
        label: "1st place",
            colors: {
            color: "#FFD700",
                gradient: 'linear-gradient(90deg,rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0.1) 40%, rgba(255, 215, 0, 0.04) 70%, rgba(255, 215, 0, 0) 100%)',
        },
    },
    second:{
        label: "2nd place",
            colors: {
            color: "#CD7F32",
                gradient: 'linear-gradient(90deg,rgba(205, 127, 50, 0.2) 0%, rgba(205, 127, 50, 0.1) 40%, rgba(205, 127, 50, 0.04) 70%, rgba(205, 127, 50, 0) 100%)',
        },
    },
    third:{
        label: "3rd place",
            colors: {
            color: "#C0C0C0",
                gradient: 'linear-gradient(90deg,rgba(192, 192, 192, 0.2) 0%, rgba(192, 192, 192, 0.1) 40%, rgba(192, 192, 192, 0.04) 70%, rgba(192, 192, 192, 0) 100%)',
        },
    },
    fourth:{
        label: "4th place",
            colors:{
            color: "#DC143C",
                gradient: 'linear-gradient(90deg,rgba(220, 20, 60, 0.2) 0%, rgba(220, 20, 60, 0.1) 40%, rgba(220, 20, 60, 0.04) 70%, rgba(220, 20, 60, 0) 100%)',
        },
    },
    fifth:{
        label: "5th place",
            colors: {
            color: "#1E90FF",
                gradient: 'linear-gradient(90deg,rgba(30, 144, 255, 0.2) 0%, rgba(30, 144, 255, 0.1) 40%, rgba(30, 144, 255, 0.04) 70%, rgba(30, 144, 255, 0) 100%)',
        },
    },
    sixth:{
        label: "6th place",
            colors: {
            color: "#9400D3",
                gradient: 'linear-gradient(90deg,rgba(148, 0, 211, 0.2) 0%, rgba(148, 0, 211, 0.1) 40%, rgba(148, 0, 211, 0.04) 70%, rgba(148, 0, 211, 0) 100%)',
        }
    }
};
export const prize_pools = {
    valorant: {
        has_phases: false,
        first: "50.000 Dhs",
        second: "30.000 Dhs",
        third: "20.000 Dhs",
        total: "100.000 Dhs",
    },
    eafc:{
        has_phases: false,
        /*quali:{
            first: "25.000 Dhs",
            second: "15.000 Dhs",
            third: "10.000 Dhs",
            total: "50.000 Dhs",
        },
        finals:{
                first: "50.000 Dhs",
                second: "30.000 Dhs",
                third: "20.000 Dhs",
                total: "100.000 Dhs",
        }*/
        first: "50.000 Dhs",
        second: "30.000 Dhs",
        third: "20.000 Dhs",
        total: "100.000 Dhs",
    },
    freefire:{
        has_phases: false,
            first: "80.000 Dhs",
            second: "50.000 Dhs",
            third: "30.000 Dhs",
            fourth: "20.000 Dhs",
            fifth: "10.000 Dhs",
            sixth: "10.000 Dhs",
            total: "200.000 Dhs",
    },
    streetfighter: {
        has_phases: false,
            first: "50.000 Dhs",
            second: "30.000 Dhs",
            third: "20.000 Dhs",
            total: "100.000 Dhs",
    }
};